import type { GalleryItem } from "~/components/design-system/molecules/MediaGalleryWithThumbnails"

interface ActivityTypeImage {
  smallUrl?: string | null
  largeUrl?: string | null
  altText?: string | null
  mediaType?: string | null
  muxPlaybackId?: string | null
}

/**
 * Maps an ActivityType's images (which the API returns ordered by position)
 * into the gallery's GalleryItem shape. Video items are turned into Mux HLS
 * playback + thumbnail URLs; videos without a ready muxPlaybackId are filtered
 * out. Ordering is preserved across images and videos.
 */
export const activityTypeImagesToGalleryItems = (
  images: ReadonlyArray<ActivityTypeImage>,
  nameFallback: string
): GalleryItem[] =>
  images
    .map((img, index): GalleryItem | null => {
      if (img.mediaType === "video") {
        if (!img.muxPlaybackId) return null
        const thumbnailSrc = `https://image.mux.com/${img.muxPlaybackId}/thumbnail.webp`
        return {
          id: `video-${index}`,
          type: "video",
          playbackUrl: `https://stream.mux.com/${img.muxPlaybackId}.m3u8`,
          thumbnailSrc,
          largeUrl: thumbnailSrc,
          smallUrl: thumbnailSrc,
          alt: img.altText ?? nameFallback
        }
      }

      if (!img.largeUrl) return null
      return {
        id: `image-${index}`,
        type: "image",
        largeUrl: img.largeUrl,
        smallUrl: img.smallUrl ?? img.largeUrl,
        alt: img.altText ?? nameFallback
      }
    })
    .filter((item): item is GalleryItem => item !== null)
